import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Auth } from '../../Component/Api/Auth/AuthService';
import { PageLayout } from '../../Component/Common/Container/PageLayout';
import { PasswordResetRequest } from '../../Component/Model/SignIn';
import TimelineIcon from '@mui/icons-material/Timeline';
import { Card, CardContent, CardHeader, Container, Grid, Icon, InputAdornment, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { InfoArea } from '../../Component/Common/Components/InfoArea/InfoArea';


const PasswordPolicy: string[] = [
    'Passwords should be between 8 and 100 characters long.',
    'Password must contain at least 3 out of the following 4 character types: Uppercase, Lowercase, Symbol, Number. ',
    'Your password cannot contain your username.',
    `Vulnerable passwords like '123456', 'password', 'p@ssword' etc are not allowed.`,
    `3 or more sequential keyboard characters like '123', 'qwe', 'jkl' are not allowed.`
]
export const ForgotPasswordPage = () => {
    const { id } = useParams<any>();
    const history = useHistory();
    const [passwordState, setPasswordState] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");
    const [confirmPasswordState, setConfirmPasswordState] = React.useState<string>("");
    const [confirmPassword, setConfirmPassword] = React.useState<string>("");
    const [loading, setLoading] = React.useState<boolean>(false);


    const verifyLength = (value: any, Minlength: number, MaxLenght: number) => {
        if (value.length >= Minlength && value.length <= MaxLenght) {
            return true;
        }
        return false;
    };


    const ResetPassword = () => {
        if (password.length < 1) {
            setPasswordState("error");
            return;
        }
        if (confirmPassword.length < 1) {
            setConfirmPasswordState("error");
            return;
        }
        if (password !== confirmPassword) {
            toast.error("Passwords do not match.");
            setPasswordState("error");
            setConfirmPasswordState("error");
            return;
        }
        try {
            setLoading(true);
            const passwordRequest: PasswordResetRequest = {
                NewPassword: password,
                ConfirmPassword: confirmPassword,
                SecurityGuid: id!.toString()
            }
            Auth.resetPassword(passwordRequest).then(result => {
                setLoading(false);
                history.push("/login");
                toast.success("Password successfully reset");
            })
        } catch (error) {
            setLoading(false);
            console.log(error);
        }

    }

    return (
        <PageLayout>
            <Container>
                <Grid container justifyContent="center" pt={28}>
                    <Grid item xs={12} sm={12} md={10}>
                        <Card>
                            <CardHeader title={'Reset your Password'} sx={{ textAlign: 'center' }}>
                            </CardHeader>
                            <CardContent>
                                <Grid container justifyContent="center">
                                    <Grid item xs={12} sm={12} md={5}>
                                        <InfoArea
                                            title="Password Policy"
                                            icon={TimelineIcon}
                                            iconColor="rose"
                                        />
                                        {PasswordPolicy.map((item, index) => {
                                            return (
                                                <p key={index}>{item}</p>
                                            )
                                        })}
                                    </Grid>
                                    <Grid item xs={12} sm={8} md={5}>
                                        <TextField
                                            error={passwordState === "error"}
                                            label="Password"
                                            id="loginpassword"
                                            fullWidth
                                            type="password"
                                            autoComplete="off"
                                            onChange={(event: any) => {
                                                if (verifyLength(event.target.value, 8, 100)) {
                                                    setPasswordState("success");
                                                } else {
                                                    setPasswordState("error");
                                                }
                                                setPassword(event.target.value);
                                            }}

                                        />
                                        <Grid container mt={2}>
                                            <TextField
                                                error={confirmPasswordState === "error"}
                                                label="Confirm Password"
                                                id="loginpassword"
                                                fullWidth
                                                type="password"
                                                autoComplete="off"
                                                onChange={(event: any) => {
                                                    if (verifyLength(event.target.value, 8, 100)) {
                                                        setConfirmPasswordState("success");
                                                    } else {
                                                        setConfirmPasswordState("error");
                                                    }
                                                    setConfirmPassword(event.target.value);
                                                }}
                                            />
                                        </Grid>
                                        <>
                                            <LoadingButton color="primary" loading={loading} onClick={ResetPassword}>
                                                Reset Password
                                            </LoadingButton>
                                        </>
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </PageLayout>
    )
}
